import React, { Component } from 'react';
import PageTitle from './PageTitle';
import {Link} from 'react-router';
 
export default class AboutRetail extends Component {

    render() {
        return (
            <div>
                <PageTitle title="Gestão para Varejo - FC Varejo" last="Home" lastLink="/" />
                <div className="promo-box brand-bg">
                    <div className="container">
                        <div className="col-md-12">
                            <div className="promo-info">
                                <span className="white-text text-uppercase">Não perca tempo organizando documentos e o financeiro de sua empresa, ultrapasse seus concorrentes.</span>
                                <h2 className="font-30 white-text text-bold text-uppercase no-margin">Controle sua empresa sem complicação</h2>
                            </div>
                            <div className="promo-btn white-text">
                                <Link className="btn white waves-effect waves-grey" to="/contact/receber-orçamento">Receber orçamento</Link>                          
                            </div>
                        </div>
                    </div>
                </div>         
                <section id="about" className="section-padding">
                    <div className="container">

                        <div className="text-center mb-80">
                            <h2 className="section-title text-uppercase">Sistema de Gestão em Varejo</h2>
                            <p className="section-sub">O Sistema FC-Varejo tem tudo que seu verejo precisa.</p>
                        </div>

                        <div className="vertical-tab">
                            <div className="row">
                                <div className="col-sm-3">
                                    <ul className="nav nav-tabs nav-stacked hidden-xs" role="tablist">
                                        <li role="presentation" className="active">
                                            <a href="#tab-retail-1" className="waves-effect waves-light" role="tab" data-toggle="tab" aria-expanded="false">Financeiro</a>
                                        </li>
                                        <li role="presentation" className="">
                                            <a href="#tab-retail-2" className="waves-effect waves-light" role="tab" data-toggle="tab" aria-expanded="false">Vendas de Produtos/Serviços</a>
                                        </li>
                                        <li role="presentation" className="">
                                            <a href="#tab-retail-3" className="waves-effect waves-light" role="tab" data-toggle="tab" aria-expanded="false">Estoque</a>
                                        </li>
                                        <li role="presentation" className="">
                                            <a href="#tab-retail-4" className="waves-effect waves-light" role="tab" data-toggle="tab" aria-expanded="false">CRM</a>
                                        </li>
                                    </ul><div className="panel-group visible-xs" id="undefined-accordion"></div>
                                </div>

                                <div className="col-sm-9">
                                    <div className="panel-body">
                                        <div className="tab-content">
                                            <div role="tabpanel" className="tab-pane fade in active" id="tab-retail-1">
                                                <h2>Módulo Financeiro</h2>

                                                <img className="alignright" width="150px" src="/assets/img/mockup/tab.png" alt="" />

                                                <div className="row">
                                                    <div className="col-sm-4">
                                                        <ul>
                                                            <li>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle contas a pagar.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de Contas a receber.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Resumo Financeiro por cliente.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de fluxo de caixa Mensal.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de fluxo de caixa diário.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Gestão de crédito dos clientes.
                                                                </h5>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-sm-4">
                                                        <ul>
                                                            <li>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Demonstrativo de resultados (DRE).
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Recuperação de crédito.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Ponto de equilibrio.
                                                                </h5>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div role="tabpanel" className="tab-pane fade" id="tab-retail-2">
                                                <h2>Módulo Vendas</h2>
                                                
                                                <img className="alignright mt-20" width="250px" src="/assets/img/idea.jpg" alt="" />

                                                <div className="row">
                                                    <div className="col-sm-4">
                                                        <ul>
                                                            <li>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Gestão de pedidos de venda.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Frente de Caixa.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Gestão de metas de venda por vendedor.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Gestão de metas de venda por departamento.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Gestão de metas de venda por filial.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Gestão de promoções.
                                                                </h5>
                                                            </li>    
                                                        </ul>
                                                    </div>        
                                                    <div className="col-sm-4">
                                                        <ul>
                                                            <li>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Comparativo mensal/anual/diário
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de Vendas em Condicional
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> SAT
                                                                </h5>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>


                                            </div>
                                            <div role="tabpanel" className="tab-pane fade" id="tab-retail-3">
                                                <h2>Gestão em Estoque</h2>

                                                <img className="alignright" width="250px" src="/assets/img/busy_man.png" alt="" />

                                                <div className="row">
                                                    <div className="col-sm-6">
                                                        <ul>
                                                            <li>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Entrada e Saida de produtos.
                                                                </h5>                                                                
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Emissão de etiquetas c/ códigos de barras.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de giro de estoque.
                                                                </h5>                                                                
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Inventário de Estoque.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Cadastro de fornecedores.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Relatórios Gerencias.
                                                                </h5>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                            </div>
                                            <div role="tabpanel" className="tab-pane fade" id="tab-retail-4">
                                                <h2>CRM - Gerenciamento de relacionamento com clentes</h2>

                                                <img className="alignright" src="/assets/img/data.png" alt="" width="250px" />

                                                <div className="row">
                                                    <div className="col-sm-6">
                                                        <ul>
                                                            <li>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle tarefas por funcionário.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de cobrança.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Agendamento de contato clientes aniversáriantes.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Resgate de clientes.
                                                                </h5>
                                                                <h5>
                                                                    <img src="/assets/img/checkbox.png" alt="" /> Controle de versões do plano orçamentário.
                                                                </h5>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>                                
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </section>
                <section className="facts-two counter-section seo-banner-1 bg-fixed parallax-bg overlay dark-6" data-stellar-background-ratio="0.5" style={{backgroundImage: 'url(../../assets/img/seo/seo-banner-1.jpg)', backgroundPosition: '0% 140.5px'}}>
                    <div className="container">
                        <div className="row text-center">
                            <div className="col-sm-3 counter-wrap">
                                <i className="material-icons brand-color"></i>
                                <span className="timer white-text">193746</span>
                                <span className="count-description white-text">Clientes cadastrados</span>
                            </div>

                            <div className="col-sm-3 counter-wrap">
                                <i className="material-icons brand-color"></i>
                                <span className="timer white-text">234088</span>
                                <span className="count-description white-text">Vendas efetivadas</span>
                            </div>   

                            <div className="col-sm-3 counter-wrap">
                                <i className="material-icons brand-color"></i>
                                <span className="timer white-text">155553</span>
                                <span className="count-description white-text">Produtos cadastrados</span>
                            </div>   

                            <div className="col-sm-3 counter-wrap">
                                <i className="material-icons brand-color"></i>
                                <span className="timer white-text">98456</span>
                                <span className="count-description white-text">SAT enviados</span>
                            </div>                                                   
                        </div>
                    </div>
                </section>
                <section className="bg-fixed parallax-bg overlay light-7 mb-100 mt-100">
                    <div className="container">
                    <div className="row">
                        <div className="col-md-7 dark-text">
                            
                            <p>Entre em contato conosco e solicite seu orçamento. </p>

                            <ul className="list-icon mb-30">
                                <li><i className="material-icons"></i> Backup automatizado.</li>
                                <li><i className="material-icons"></i> Suporte/Atendimento Online e presencial.</li>
                                <li><i className="material-icons"></i> Orçamento sem nenhum compromisso.</li>
                            </ul>

                            <Link className="btn btn-lg text-capitalize waves-effect waves-light" to="/contact/fazer-orçamento">Fazer orçamento</Link> 

                        </div>

                        <div className="col-md-5 mt-sm-30">
                            <img className="alignright" src="/assets/img/seo/tab-2.png" alt="" />
                        </div>
                    </div>
                </div>
            </section>                 
         </div>    
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/AboutRetail.js